var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[(_vm.routerReady)?_c(_vm.layout + '-layout',{tag:"component"}):_c('div',{staticClass:"relative w-screen h-screen"},[_c('div',{staticClass:"absolute inset-0 top-20 flex justify-center"},[_c('app-loading-indicator',{staticClass:"w-7 h-7"})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }